// Яндекс.Метрика грузится только после согласия пользователя (cookie-баннер).
// Согласие хранится в localStorage под ключом cookie_consent.

const METRIKA_COUNTER_ID = 88946749;
const CONSENT_STORAGE_KEY = 'cookie_consent';

export const CONSENT_ACCEPTED = 'accepted';
export const CONSENT_DECLINED = 'declined';

let started = false;

export function getConsent() {
  try {
    return window.localStorage.getItem(CONSENT_STORAGE_KEY);
  } catch (e) {
    // приватный режим / localStorage недоступен
    return null;
  }
}

export function saveConsent(value) {
  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, value);
  } catch (e) {
    // приватный режим / localStorage недоступен — баннер показывается заново
  }
}

export function isMetrikaAllowed() {
  return getConsent() === CONSENT_ACCEPTED;
}

/**
 * Загружает счётчик Яндекс.Метрики. Повторные вызовы игнорируются,
 * без сохранённого согласия ничего не грузится.
 * @returns {boolean} true, если загрузка была запущена
 */
export function initMetrika() {
  if (started || typeof window === 'undefined' || !isMetrikaAllowed()) {
    return false;
  }
  started = true;

  window.ym =
    window.ym ||
    function () {
      (window.ym.a = window.ym.a || []).push(arguments);
    };
  window.ym.l = 1 * new Date();

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://mc.yandex.ru/metrika/tag.js';

  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }

  window.ym(METRIKA_COUNTER_ID, 'init', {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
  });

  return true;
}
